<template src="./submission-mediator.html"></template>

<script lang="ts">
import submissionPageComponents from './submission-page-components'
import submissionStore from 'store/submission-store'


export default {
  data() {
    return {
      submissionStoreState: submissionStore.state
    }
  },
  emits: ['pageLoaded', 'pageLoading', 'showError', 'showPopoverMessage'],
  computed: {
    currentPage() {
      return this.submissionStoreState.currentPage ?
        submissionPageComponents[this.submissionStoreState.currentPage.page] : null
    },
    currentPageProps() {
      return this.submissionStoreState.currentPage ?
        this.submissionStoreState.currentPage.props : {}
    }
  },
  methods: {
    onShowError(message, endFlow = false, autoClose = true) {
      this.$emit('showError', message, endFlow, autoClose)
    },
    onShowPopoverMessage(message, endFlow = false) {
      this.$emit('showPopoverMessage', message, endFlow)
    },
    pageLoaded(preventClickOutside = false) {
      this.$emit('pageLoaded', preventClickOutside)
    },
    pageLoading() {
      this.$emit('pageLoading')
    }
  },
  beforeUnmount() {
    // before the review submission flow is destroyed, resetting the review submission store
    // so that if opened again, it does not have any lingering values from before.
    submissionStore.resetStore()
  },
  watch: {
    currentPage() {
      this.pageLoading()
    }
  }
}
</script>

<style lang="scss" src="./submission-mediator.scss"></style>
